/**
 * 동경교과서협회 중등학교 직원록 목록 데이터
 */
const MiddleSchoolData = [
    {
        "book_id" : 10984,
        "book_type" : null,
        "book_category" : "middle_school_redbook",
        "book_title" : "師範學校 中學校 職員錄",
        "book_title_ko" : "사범학교 중학교 직원록",
        "numeration" : "昭和13年5月末現在, 第35版",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1938,
        "publish_month" : 9,
        "publish_day" : 20,
        "publish_date" : "昭和13年9月20日",
        "publisher" : "東京 中等敎科書協會",
        "publisher_ko" : "도쿄 중등교과서협회",
        "library" : "(日本)国立国会図書館",
        "url" : null,
        "note" : null,
        "search_tag" : "師範學校 中學校 職員錄昭和13年5月末現在, 第35版昭和13年9月20日",
        "usernote" : null
    },
    {
        "book_id" : 10985,
        "book_type" : null,
        "book_category" : "middle_school_redbook",
        "book_title" : "實業學校 職員錄",
        "book_title_ko" : "실업학교 직원록",
        "numeration" : "昭和13年5月末現在, 第35版",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1938,
        "publish_month" : 9,
        "publish_day" : 20,
        "publish_date" : "昭和13年9月20日",
        "publisher" : "東京 中等敎科書協會",
        "publisher_ko" : "도쿄 중등교과서협회",
        "library" : "(日本)国立国会図書館",
        "url" : null,
        "note" : null,
        "search_tag" : "實業學校 職員錄昭和13年5月末現在, 第35版昭和13年9月20日",
        "usernote" : null
    },
    {
        "book_id" : 10986,
        "book_type" : null,
        "book_category" : "middle_school_redbook",
        "book_title" : "師範學校 中學校 職員錄",
        "book_title_ko" : "사범학교 중학교 직원록",
        "numeration" : "昭和14年5月末現在, 第36版",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1939,
        "publish_month" : 9,
        "publish_day" : 1,
        "publish_date" : "昭和14年9月1日",
        "publisher" : "東京 中等敎科書協會",
        "publisher_ko" : "도쿄 중등교과서협회",
        "library" : "(日本)国立国会図書館",
        "url" : null,
        "note" : null,
        "search_tag" : "師範學校 中學校 職員錄昭和14年5月末現在, 第36版昭和14年9月1日",
        "usernote" : null
    },
    {
        "book_id" : 10987,
        "book_type" : null,
        "book_category" : "middle_school_redbook",
        "book_title" : "高等女學校 女子實業學校 職員錄",
        "book_title_ko" : "고등여학교 여자실업학교 직원록",
        "numeration" : "昭和13年5月末現在, 第35版",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1938,
        "publish_month" : 9,
        "publish_day" : 20,
        "publish_date" : "昭和13年9月20日",
        "publisher" : "東京 中等敎科書協會",
        "publisher_ko" : "도쿄 중등교과서협회",
        "library" : "(日本)国立国会図書館",
        "url" : null,
        "note" : null,
        "search_tag" : "高等女學校 女子實業學校 職員錄昭和13年5月末現在, 第35版昭和13年9月20日",
        "usernote" : null
    },
    {
        "book_id" : 10988,
        "book_type" : null,
        "book_category" : "middle_school_redbook",
        "book_title" : "中等敎育 諸學校 職員錄",
        "book_title_ko" : "중등교육 제학교 직원록",
        "numeration" : "昭和12年5月末現在, 第34版",
        "authors" : null,
        "authors_ko" : null,
        "publish_info" : null,
        "publish_year" : 1937,
        "publish_month" : 9,
        "publish_day" : 1,
        "publish_date" : "昭和12年9月1日",
        "publisher" : "東京 中等敎科書協會",
        "publisher_ko" : "도쿄 중등교과서협회",
        "library" : "(日本)国立国会図書館",
        "url" : null,
        "note" : null,
        "search_tag" : "中等敎育 諸學校 職員錄昭和12年5月末現在, 第34版昭和12年9月1日",
        "usernote" : null
    }
]

export default MiddleSchoolData;